import { render, staticRenderFns } from "./BuilderSteps.vue?vue&type=template&id=2894c85f&scoped=true"
import script from "./BuilderSteps.vue?vue&type=script&lang=js"
export * from "./BuilderSteps.vue?vue&type=script&lang=js"
import style0 from "./BuilderSteps.vue?vue&type=style&index=0&id=2894c85f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2894c85f",
  null
  
)

export default component.exports